import _default from './Checkbox';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Checkbox/index.js
// module id = 277
// module chunks = 0